import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";


const ErrorDialog = (props: any) => {
    const { onClose, errorTitle, errorMessage, open } = props;
  
    const handleClose = () => {
      onClose();
    };
  
    return (
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
            {errorTitle || "Error"}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {errorMessage}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} autoFocus>
            OK
            </Button>
        </DialogActions>
        </Dialog>
      );
  };

export default ErrorDialog;